'use strict';

var _ = require('lodash');
function GridDynamicConfigDrivenColumnStrategiesService(dataRetriever, dataRetrieverConstant, $q) {
  var hepRetriever = dataRetriever.getDataRetriever(dataRetrieverConstant.SYSTEM_STATUS_SCREEN, dataRetrieverConstant.SYSTEM_STATUS_CONFIGURATION_PARAMETERS_ADVANCED_MODE);
  var strategies = {
    bookingIntakeHep: bookingIntakeHepStrategy
  };
  function transform(dynamicColumns, dataFields) {
    hepRetriever.selectedParams({
      isDefault: true,
      type: 'BookingsIntakeDaysOffsets'
    });
    return hepRetriever.retrieveData().then(function (hepData) {
      var dayOffsets = _.chain(hepData).get('0.daysOffsets', []).sortBy().value();
      return $q.all(_.map(dynamicColumns, function (dynamicColumn) {
        if (_.isEmpty(dynamicColumn.dynamicConfigDrivenColumn)) {
          return dynamicColumn;
        }
        return $q.all(_.map(dynamicColumn.dynamicConfigDrivenColumn, function (dynamicConfigColumn) {
          return strategies[dynamicConfigColumn.strategy](dynamicConfigColumn, dynamicColumn, dataFields, dayOffsets);
        })).then(function (columnsTransformed) {
          var collectedColumns = _.reduce(columnsTransformed, function (accumulator, columns) {
            return accumulator.concat(columns);
          }, []);
          dynamicColumn.columns = dynamicColumn.transformColumns(collectedColumns, dynamicColumn.gridId);
          return dynamicColumn;
        });
      }));
    });
  }
  function bookingIntakeHepStrategy(column, dynamicColumn, dataFields, dayOffsets) {
    return $q.when(dayOffsets).then(function (intakeOffsets) {
      return _.map(intakeOffsets, function (intakeOffset) {
        var dataColumn = _.defaultsDeep({}, column);
        var fieldName = dataColumn.field + intakeOffset;
        dataColumn.title = intakeOffset;
        dataColumn.field = fieldName;
        dataColumn.gridId = dynamicColumn.gridId;
        dataFields.push({
          name: fieldName,
          type: column.dataFieldType || 'number'
        });
        return dataColumn;
      });
    });
  }
  return {
    transform: transform
  };
}
GridDynamicConfigDrivenColumnStrategiesService.$inject = ['DataRetrieverService', 'DataRetrieverConstantsService', '$q'];
module.exports = GridDynamicConfigDrivenColumnStrategiesService;